import axios from './axios'

export const youTubeLength = async id => {
  const { data } = await axios.get('/media/yt-length/' + id)
  return data
}

export const youTubeIsPrivate = async id => {
  const { data } = await axios.get('/media/yt-is-private/' + id)
  console.log(data, id)
  return data
}

export const generateAIImage = async ({ prompt, previewOnly = true }) => {
  if (import.meta.env.VITE_MOCK_AI_IMAGE === 'true') {
    return { url: `https://picsum.photos/1200/850?seed=${Math.random()}` }
  }
  const { data } = await axios.post('/media/ai-generate', {
    prompt,
    previewOnly,
  })
  return data
}

export const editAIImage = async ({
  prompt,
  imageId,
  strength,
  imageStream,
  previewOnly = true,
}) => {
  if (import.meta.env.VITE_MOCK_AI_IMAGE === 'true') {
    return { url: `https://picsum.photos/1200/850?seed=${Math.random()}` }
  }
  const { data } = await axios.post('/media/ai-edit', {
    prompt,
    imageId,
    strength,
    imageStream,
    previewOnly,
  })
  return data
}

export const saveAIImage = async ({ url, title }) => {
  const { data } = await axios.post('/media/ai-save', {
    url,
    title,
  })
  return data
}
